var map = {
	"./assets/Bulk Upload Sample.csv": "./src/assets/Bulk Upload Sample.csv",
	"./assets/audio.svg": "./src/assets/audio.svg?ec31",
	"./assets/catord.svg": "./src/assets/catord.svg?a898",
	"./assets/check.svg": "./src/assets/check.svg?fd9a",
	"./assets/contest.svg": "./src/assets/contest.svg?5945",
	"./assets/create.svg": "./src/assets/create.svg?f87a",
	"./assets/delete.gif": "./src/assets/delete.gif",
	"./assets/delete2.gif": "./src/assets/delete2.gif",
	"./assets/delete3.gif": "./src/assets/delete3.gif",
	"./assets/done.gif": "./src/assets/done.gif",
	"./assets/edit.svg": "./src/assets/edit.svg?c7b1",
	"./assets/file-icon.png": "./src/assets/file-icon.png",
	"./assets/fonts/Akira.otf": "./src/assets/fonts/Akira.otf",
	"./assets/fonts/ClashDisplay-Regular.otf": "./src/assets/fonts/ClashDisplay-Regular.otf",
	"./assets/fonts/K2D.ttf": "./src/assets/fonts/K2D.ttf",
	"./assets/fonts/Krub-Regular.woff": "./src/assets/fonts/Krub-Regular.woff",
	"./assets/fonts/Lato-Regular.ttf": "./src/assets/fonts/Lato-Regular.ttf",
	"./assets/fonts/Mulish-VariableFont_wght.ttf": "./src/assets/fonts/Mulish-VariableFont_wght.ttf",
	"./assets/fonts/Nunito-Regular.ttf": "./src/assets/fonts/Nunito-Regular.ttf",
	"./assets/fonts/Poppins-Regular.otf": "./src/assets/fonts/Poppins-Regular.otf",
	"./assets/fonts/Sansation_Regular.ttf": "./src/assets/fonts/Sansation_Regular.ttf",
	"./assets/fonts/Segoe UI.ttf": "./src/assets/fonts/Segoe UI.ttf",
	"./assets/fonts/WorkSans-VariableFont_wght.ttf": "./src/assets/fonts/WorkSans-VariableFont_wght.ttf",
	"./assets/funico.svg": "./src/assets/funico.svg?a0e9",
	"./assets/guessico.svg": "./src/assets/guessico.svg?40e0",
	"./assets/import.svg": "./src/assets/import.svg?7371",
	"./assets/loginbg.png": "./src/assets/loginbg.png",
	"./assets/loginbg2.png": "./src/assets/loginbg2.png",
	"./assets/loginimg.png": "./src/assets/loginimg.png",
	"./assets/logo2.svg": "./src/assets/logo2.svg?ae86",
	"./assets/logolight.svg": "./src/assets/logolight.svg?5ccf",
	"./assets/mail.svg": "./src/assets/mail.svg?78dc",
	"./assets/main.svg": "./src/assets/main.svg?b64b",
	"./assets/manage.svg": "./src/assets/manage.svg?f28e",
	"./assets/manageico.svg": "./src/assets/manageico.svg?1905",
	"./assets/more - vertical.svg": "./src/assets/more - vertical.svg?4ce6",
	"./assets/notification.svg": "./src/assets/notification.svg?ece0",
	"./assets/profile.svg": "./src/assets/profile.svg?4015",
	"./assets/questionico.svg": "./src/assets/questionico.svg?f177",
	"./assets/questiontable.svg": "./src/assets/questiontable.svg?de4c",
	"./assets/reports.svg": "./src/assets/reports.svg?08a4",
	"./assets/search.svg": "./src/assets/search.svg?daa2",
	"./assets/settings.svg": "./src/assets/settings.svg",
	"./assets/sidebar-icons/activities.svg": "./src/assets/sidebar-icons/activities.svg?93c7",
	"./assets/sidebar-icons/activity-active.svg": "./src/assets/sidebar-icons/activity-active.svg?6130",
	"./assets/sidebar-icons/audio-active.svg": "./src/assets/sidebar-icons/audio-active.svg?7ed8",
	"./assets/sidebar-icons/audio.svg": "./src/assets/sidebar-icons/audio.svg?5f4f",
	"./assets/sidebar-icons/contest-active.svg": "./src/assets/sidebar-icons/contest-active.svg?cdac",
	"./assets/sidebar-icons/contest.svg": "./src/assets/sidebar-icons/contest.svg?953f",
	"./assets/sidebar-icons/daily-quiz-active.svg": "./src/assets/sidebar-icons/daily-quiz-active.svg?434a",
	"./assets/sidebar-icons/daily-quiz.svg": "./src/assets/sidebar-icons/daily-quiz.svg?5289",
	"./assets/sidebar-icons/dashboard-active.svg": "./src/assets/sidebar-icons/dashboard-active.svg?f36e",
	"./assets/sidebar-icons/dashboard.svg": "./src/assets/sidebar-icons/dashboard.svg?c40b",
	"./assets/sidebar-icons/exam-module-active.svg": "./src/assets/sidebar-icons/exam-module-active.svg?586d",
	"./assets/sidebar-icons/exam-module.svg": "./src/assets/sidebar-icons/exam-module.svg?c600",
	"./assets/sidebar-icons/fun-active.svg": "./src/assets/sidebar-icons/fun-active.svg?d308",
	"./assets/sidebar-icons/fun.svg": "./src/assets/sidebar-icons/fun.svg?3aba",
	"./assets/sidebar-icons/guess-active.svg": "./src/assets/sidebar-icons/guess-active.svg?45b3",
	"./assets/sidebar-icons/guess-word.svg": "./src/assets/sidebar-icons/guess-word.svg?4187",
	"./assets/sidebar-icons/leaderboard-active.svg": "./src/assets/sidebar-icons/leaderboard-active.svg?8fea",
	"./assets/sidebar-icons/leaderboard.svg": "./src/assets/sidebar-icons/leaderboard.svg?9586",
	"./assets/sidebar-icons/logout.svg": "./src/assets/sidebar-icons/logout.svg?76c8",
	"./assets/sidebar-icons/math-quiz-active.svg": "./src/assets/sidebar-icons/math-quiz-active.svg?98b4",
	"./assets/sidebar-icons/math-quiz.svg": "./src/assets/sidebar-icons/math-quiz.svg?ccf0",
	"./assets/sidebar-icons/notification-active.svg": "./src/assets/sidebar-icons/notification-active.svg?1bac",
	"./assets/sidebar-icons/notification.svg": "./src/assets/sidebar-icons/notification.svg?e82c",
	"./assets/sidebar-icons/payment-active.svg": "./src/assets/sidebar-icons/payment-active.svg?4739",
	"./assets/sidebar-icons/payments.svg": "./src/assets/sidebar-icons/payments.svg?5a96",
	"./assets/sidebar-icons/quiz-active.svg": "./src/assets/sidebar-icons/quiz-active.svg?a54c",
	"./assets/sidebar-icons/quiz-zone.svg": "./src/assets/sidebar-icons/quiz-zone.svg?5918",
	"./assets/sidebar-icons/settings-active.svg": "./src/assets/sidebar-icons/settings-active.svg?9e2a",
	"./assets/sidebar-icons/settings.svg": "./src/assets/sidebar-icons/settings.svg?dbe8",
	"./assets/sidebar-icons/user-active.svg": "./src/assets/sidebar-icons/user-active.svg?9598",
	"./assets/sidebar-icons/users.svg": "./src/assets/sidebar-icons/users.svg?ca1f",
	"./assets/sliderimg.png": "./src/assets/sliderimg.png",
	"./assets/sms.svg": "./src/assets/sms.svg?22d5",
	"./assets/subcat.svg": "./src/assets/subcat.svg?7e20",
	"./assets/subico.svg": "./src/assets/subico.svg?0ea7",
	"./assets/tableimg.png": "./src/assets/tableimg.png",
	"./assets/totalico.svg": "./src/assets/totalico.svg?c5f0",
	"./assets/view.svg": "./src/assets/view.svg?908f",
	"./components/Logo": "./src/components/Logo/index.jsx",
	"./components/Logo/": "./src/components/Logo/index.jsx",
	"./components/Logo/index": "./src/components/Logo/index.jsx",
	"./components/Logo/index.jsx": "./src/components/Logo/index.jsx",
	"./components/buttons/button": "./src/components/buttons/button.jsx",
	"./components/buttons/button.jsx": "./src/components/buttons/button.jsx",
	"./components/buttons/loading.css": "./src/components/buttons/loading.css",
	"./components/buttons/modalbtn": "./src/components/buttons/modalbtn.jsx",
	"./components/buttons/modalbtn.jsx": "./src/components/buttons/modalbtn.jsx",
	"./components/charts/areachart": "./src/components/charts/areachart/index.jsx",
	"./components/charts/areachart/": "./src/components/charts/areachart/index.jsx",
	"./components/charts/areachart/index": "./src/components/charts/areachart/index.jsx",
	"./components/charts/areachart/index.jsx": "./src/components/charts/areachart/index.jsx",
	"./components/charts/barchart": "./src/components/charts/barchart/index.jsx",
	"./components/charts/barchart/": "./src/components/charts/barchart/index.jsx",
	"./components/charts/barchart/index": "./src/components/charts/barchart/index.jsx",
	"./components/charts/barchart/index.jsx": "./src/components/charts/barchart/index.jsx",
	"./components/inputs/fileinputs": "./src/components/inputs/fileinputs.jsx",
	"./components/inputs/fileinputs.jsx": "./src/components/inputs/fileinputs.jsx",
	"./components/inputs/radioinputs": "./src/components/inputs/radioinputs.jsx",
	"./components/inputs/radioinputs.jsx": "./src/components/inputs/radioinputs.jsx",
	"./components/inputs/selectinputs": "./src/components/inputs/selectinputs.jsx",
	"./components/inputs/selectinputs.jsx": "./src/components/inputs/selectinputs.jsx",
	"./components/inputs/textarea": "./src/components/inputs/textarea.jsx",
	"./components/inputs/textarea.jsx": "./src/components/inputs/textarea.jsx",
	"./components/inputs/textinputs": "./src/components/inputs/textinputs.jsx",
	"./components/inputs/textinputs.jsx": "./src/components/inputs/textinputs.jsx",
	"./components/maincontainer": "./src/components/maincontainer/index.jsx",
	"./components/maincontainer/": "./src/components/maincontainer/index.jsx",
	"./components/maincontainer/index": "./src/components/maincontainer/index.jsx",
	"./components/maincontainer/index.jsx": "./src/components/maincontainer/index.jsx",
	"./components/mainheader": "./src/components/mainheader/index.jsx",
	"./components/mainheader/": "./src/components/mainheader/index.jsx",
	"./components/mainheader/index": "./src/components/mainheader/index.jsx",
	"./components/mainheader/index.jsx": "./src/components/mainheader/index.jsx",
	"./components/modals/add-badge": "./src/components/modals/add-badge.jsx",
	"./components/modals/add-badge.jsx": "./src/components/modals/add-badge.jsx",
	"./components/modals/add-faq": "./src/components/modals/add-faq.jsx",
	"./components/modals/add-faq.jsx": "./src/components/modals/add-faq.jsx",
	"./components/modals/add-language": "./src/components/modals/add-language.jsx",
	"./components/modals/add-language.jsx": "./src/components/modals/add-language.jsx",
	"./components/modals/add-slider": "./src/components/modals/add-slider.jsx",
	"./components/modals/add-slider.jsx": "./src/components/modals/add-slider.jsx",
	"./components/modals/add-users": "./src/components/modals/add-users.jsx",
	"./components/modals/add-users.jsx": "./src/components/modals/add-users.jsx",
	"./components/modals/confirm-delete": "./src/components/modals/confirm-delete.jsx",
	"./components/modals/confirm-delete.jsx": "./src/components/modals/confirm-delete.jsx",
	"./components/modals/create-category": "./src/components/modals/create-category.jsx",
	"./components/modals/create-category.jsx": "./src/components/modals/create-category.jsx",
	"./components/modals/create-sub-category": "./src/components/modals/create-sub-category.jsx",
	"./components/modals/create-sub-category.jsx": "./src/components/modals/create-sub-category.jsx",
	"./components/modals/deleted-modal": "./src/components/modals/deleted-modal.jsx",
	"./components/modals/deleted-modal.jsx": "./src/components/modals/deleted-modal.jsx",
	"./components/modals/done-modal": "./src/components/modals/done-modal.jsx",
	"./components/modals/done-modal.jsx": "./src/components/modals/done-modal.jsx",
	"./components/modals/edit-slider.jsx": "./src/components/modals/edit-slider.jsx/index.jsx",
	"./components/modals/edit-slider.jsx/": "./src/components/modals/edit-slider.jsx/index.jsx",
	"./components/modals/edit-slider.jsx/index": "./src/components/modals/edit-slider.jsx/index.jsx",
	"./components/modals/edit-slider.jsx/index.jsx": "./src/components/modals/edit-slider.jsx/index.jsx",
	"./components/modals/modalcontainer": "./src/components/modals/modalcontainer.jsx",
	"./components/modals/modalcontainer.jsx": "./src/components/modals/modalcontainer.jsx",
	"./components/modals/sendemail": "./src/components/modals/sendemail.jsx",
	"./components/modals/sendemail.jsx": "./src/components/modals/sendemail.jsx",
	"./components/modals/sendsms": "./src/components/modals/sendsms.jsx",
	"./components/modals/sendsms.jsx": "./src/components/modals/sendsms.jsx",
	"./components/modals/status-modal": "./src/components/modals/status-modal.jsx",
	"./components/modals/status-modal.jsx": "./src/components/modals/status-modal.jsx",
	"./components/sidebar/sidebar": "./src/components/sidebar/sidebar.jsx",
	"./components/sidebar/sidebar.jsx": "./src/components/sidebar/sidebar.jsx",
	"./components/tables/activities-table": "./src/components/tables/activities-table/index.jsx",
	"./components/tables/activities-table/": "./src/components/tables/activities-table/index.jsx",
	"./components/tables/activities-table/index": "./src/components/tables/activities-table/index.jsx",
	"./components/tables/activities-table/index.jsx": "./src/components/tables/activities-table/index.jsx",
	"./components/tables/audio-table": "./src/components/tables/audio-table/index.jsx",
	"./components/tables/audio-table/": "./src/components/tables/audio-table/index.jsx",
	"./components/tables/audio-table/index": "./src/components/tables/audio-table/index.jsx",
	"./components/tables/audio-table/index.jsx": "./src/components/tables/audio-table/index.jsx",
	"./components/tables/contest-table": "./src/components/tables/contest-table/index.jsx",
	"./components/tables/contest-table/": "./src/components/tables/contest-table/index.jsx",
	"./components/tables/contest-table/index": "./src/components/tables/contest-table/index.jsx",
	"./components/tables/contest-table/index.jsx": "./src/components/tables/contest-table/index.jsx",
	"./components/tables/exam-module-table": "./src/components/tables/exam-module-table/index.jsx",
	"./components/tables/exam-module-table/": "./src/components/tables/exam-module-table/index.jsx",
	"./components/tables/exam-module-table/index": "./src/components/tables/exam-module-table/index.jsx",
	"./components/tables/exam-module-table/index.jsx": "./src/components/tables/exam-module-table/index.jsx",
	"./components/tables/fun-table": "./src/components/tables/fun-table/index.jsx",
	"./components/tables/fun-table/": "./src/components/tables/fun-table/index.jsx",
	"./components/tables/fun-table/index": "./src/components/tables/fun-table/index.jsx",
	"./components/tables/fun-table/index.jsx": "./src/components/tables/fun-table/index.jsx",
	"./components/tables/guess-table": "./src/components/tables/guess-table/index.jsx",
	"./components/tables/guess-table/": "./src/components/tables/guess-table/index.jsx",
	"./components/tables/guess-table/index": "./src/components/tables/guess-table/index.jsx",
	"./components/tables/guess-table/index.jsx": "./src/components/tables/guess-table/index.jsx",
	"./components/tables/language-table": "./src/components/tables/language-table/index.jsx",
	"./components/tables/language-table/": "./src/components/tables/language-table/index.jsx",
	"./components/tables/language-table/index": "./src/components/tables/language-table/index.jsx",
	"./components/tables/language-table/index.jsx": "./src/components/tables/language-table/index.jsx",
	"./components/tables/leaderboard-table": "./src/components/tables/leaderboard-table/index.jsx",
	"./components/tables/leaderboard-table/": "./src/components/tables/leaderboard-table/index.jsx",
	"./components/tables/leaderboard-table/index": "./src/components/tables/leaderboard-table/index.jsx",
	"./components/tables/leaderboard-table/index.jsx": "./src/components/tables/leaderboard-table/index.jsx",
	"./components/tables/maintable": "./src/components/tables/maintable/index.jsx",
	"./components/tables/maintable/": "./src/components/tables/maintable/index.jsx",
	"./components/tables/maintable/index": "./src/components/tables/maintable/index.jsx",
	"./components/tables/maintable/index.jsx": "./src/components/tables/maintable/index.jsx",
	"./components/tables/math-quiz-table": "./src/components/tables/math-quiz-table/index.jsx",
	"./components/tables/math-quiz-table/": "./src/components/tables/math-quiz-table/index.jsx",
	"./components/tables/math-quiz-table/index": "./src/components/tables/math-quiz-table/index.jsx",
	"./components/tables/math-quiz-table/index.jsx": "./src/components/tables/math-quiz-table/index.jsx",
	"./components/tables/notification-table": "./src/components/tables/notification-table/index.jsx",
	"./components/tables/notification-table/": "./src/components/tables/notification-table/index.jsx",
	"./components/tables/notification-table/index": "./src/components/tables/notification-table/index.jsx",
	"./components/tables/notification-table/index.jsx": "./src/components/tables/notification-table/index.jsx",
	"./components/tables/payment-table": "./src/components/tables/payment-table/index.jsx",
	"./components/tables/payment-table/": "./src/components/tables/payment-table/index.jsx",
	"./components/tables/payment-table/index": "./src/components/tables/payment-table/index.jsx",
	"./components/tables/payment-table/index.jsx": "./src/components/tables/payment-table/index.jsx",
	"./components/tables/questions-table": "./src/components/tables/questions-table/index.jsx",
	"./components/tables/questions-table/": "./src/components/tables/questions-table/index.jsx",
	"./components/tables/questions-table/index": "./src/components/tables/questions-table/index.jsx",
	"./components/tables/questions-table/index.jsx": "./src/components/tables/questions-table/index.jsx",
	"./components/tables/quiz-zone-table": "./src/components/tables/quiz-zone-table/index.jsx",
	"./components/tables/quiz-zone-table/": "./src/components/tables/quiz-zone-table/index.jsx",
	"./components/tables/quiz-zone-table/index": "./src/components/tables/quiz-zone-table/index.jsx",
	"./components/tables/quiz-zone-table/index.jsx": "./src/components/tables/quiz-zone-table/index.jsx",
	"./components/tables/report-table": "./src/components/tables/report-table/index.jsx",
	"./components/tables/report-table/": "./src/components/tables/report-table/index.jsx",
	"./components/tables/report-table/index": "./src/components/tables/report-table/index.jsx",
	"./components/tables/report-table/index.jsx": "./src/components/tables/report-table/index.jsx",
	"./components/tables/sliders-table": "./src/components/tables/sliders-table/index.jsx",
	"./components/tables/sliders-table/": "./src/components/tables/sliders-table/index.jsx",
	"./components/tables/sliders-table/index": "./src/components/tables/sliders-table/index.jsx",
	"./components/tables/sliders-table/index.jsx": "./src/components/tables/sliders-table/index.jsx",
	"./components/tables/user-activity-table": "./src/components/tables/user-activity-table/index.jsx",
	"./components/tables/user-activity-table/": "./src/components/tables/user-activity-table/index.jsx",
	"./components/tables/user-activity-table/index": "./src/components/tables/user-activity-table/index.jsx",
	"./components/tables/user-activity-table/index.jsx": "./src/components/tables/user-activity-table/index.jsx",
	"./components/tables/user-contes-table": "./src/components/tables/user-contes-table/index.jsx",
	"./components/tables/user-contes-table/": "./src/components/tables/user-contes-table/index.jsx",
	"./components/tables/user-contes-table/index": "./src/components/tables/user-contes-table/index.jsx",
	"./components/tables/user-contes-table/index.jsx": "./src/components/tables/user-contes-table/index.jsx",
	"./components/tables/user-lead-table": "./src/components/tables/user-lead-table/index.jsx",
	"./components/tables/user-lead-table/": "./src/components/tables/user-lead-table/index.jsx",
	"./components/tables/user-lead-table/index": "./src/components/tables/user-lead-table/index.jsx",
	"./components/tables/user-lead-table/index.jsx": "./src/components/tables/user-lead-table/index.jsx",
	"./components/tables/user-payment-table": "./src/components/tables/user-payment-table/index.jsx",
	"./components/tables/user-payment-table/": "./src/components/tables/user-payment-table/index.jsx",
	"./components/tables/user-payment-table/index": "./src/components/tables/user-payment-table/index.jsx",
	"./components/tables/user-payment-table/index.jsx": "./src/components/tables/user-payment-table/index.jsx",
	"./data/Config": "./src/data/Config.js",
	"./data/Config.js": "./src/data/Config.js",
	"./data/Context": "./src/data/Context.jsx",
	"./data/Context.jsx": "./src/data/Context.jsx",
	"./data/Reducers": "./src/data/Reducers/index.js",
	"./data/Reducers/": "./src/data/Reducers/index.js",
	"./data/Reducers/AudioQuizReducer": "./src/data/Reducers/AudioQuizReducer.js",
	"./data/Reducers/AudioQuizReducer.js": "./src/data/Reducers/AudioQuizReducer.js",
	"./data/Reducers/BadgeReducer": "./src/data/Reducers/BadgeReducer.js",
	"./data/Reducers/BadgeReducer.js": "./src/data/Reducers/BadgeReducer.js",
	"./data/Reducers/CategoryReducer": "./src/data/Reducers/CategoryReducer.js",
	"./data/Reducers/CategoryReducer.js": "./src/data/Reducers/CategoryReducer.js",
	"./data/Reducers/ContestReducer": "./src/data/Reducers/ContestReducer.js",
	"./data/Reducers/ContestReducer.js": "./src/data/Reducers/ContestReducer.js",
	"./data/Reducers/DailyQuizReducer": "./src/data/Reducers/DailyQuizReducer.js",
	"./data/Reducers/DailyQuizReducer.js": "./src/data/Reducers/DailyQuizReducer.js",
	"./data/Reducers/ErrorReducer": "./src/data/Reducers/ErrorReducer.js",
	"./data/Reducers/ErrorReducer.js": "./src/data/Reducers/ErrorReducer.js",
	"./data/Reducers/ExamReducer": "./src/data/Reducers/ExamReducer.js",
	"./data/Reducers/ExamReducer.js": "./src/data/Reducers/ExamReducer.js",
	"./data/Reducers/FaqReducer": "./src/data/Reducers/FaqReducer.js",
	"./data/Reducers/FaqReducer.js": "./src/data/Reducers/FaqReducer.js",
	"./data/Reducers/FunNLearnReducer": "./src/data/Reducers/FunNLearnReducer.js",
	"./data/Reducers/FunNLearnReducer.js": "./src/data/Reducers/FunNLearnReducer.js",
	"./data/Reducers/GuessTheWordReducer": "./src/data/Reducers/GuessTheWordReducer.js",
	"./data/Reducers/GuessTheWordReducer.js": "./src/data/Reducers/GuessTheWordReducer.js",
	"./data/Reducers/LanguagesReducer": "./src/data/Reducers/LanguagesReducer.js",
	"./data/Reducers/LanguagesReducer.js": "./src/data/Reducers/LanguagesReducer.js",
	"./data/Reducers/LeaderboardReducer": "./src/data/Reducers/LeaderboardReducer.js",
	"./data/Reducers/LeaderboardReducer.js": "./src/data/Reducers/LeaderboardReducer.js",
	"./data/Reducers/MathQuizReducer": "./src/data/Reducers/MathQuizReducer.js",
	"./data/Reducers/MathQuizReducer.js": "./src/data/Reducers/MathQuizReducer.js",
	"./data/Reducers/PlayerReducer": "./src/data/Reducers/PlayerReducer.js",
	"./data/Reducers/PlayerReducer.js": "./src/data/Reducers/PlayerReducer.js",
	"./data/Reducers/QuestionBankReducer": "./src/data/Reducers/QuestionBankReducer.js",
	"./data/Reducers/QuestionBankReducer.js": "./src/data/Reducers/QuestionBankReducer.js",
	"./data/Reducers/QuizZoneReducer": "./src/data/Reducers/QuizZoneReducer.js",
	"./data/Reducers/QuizZoneReducer.js": "./src/data/Reducers/QuizZoneReducer.js",
	"./data/Reducers/SettingsReducer": "./src/data/Reducers/SettingsReducer.js",
	"./data/Reducers/SettingsReducer.js": "./src/data/Reducers/SettingsReducer.js",
	"./data/Reducers/SliderReducer": "./src/data/Reducers/SliderReducer.js",
	"./data/Reducers/SliderReducer.js": "./src/data/Reducers/SliderReducer.js",
	"./data/Reducers/UserReducer": "./src/data/Reducers/UserReducer.js",
	"./data/Reducers/UserReducer.js": "./src/data/Reducers/UserReducer.js",
	"./data/Reducers/index": "./src/data/Reducers/index.js",
	"./data/Reducers/index.js": "./src/data/Reducers/index.js",
	"./data/Store": "./src/data/Store.js",
	"./data/Store.js": "./src/data/Store.js",
	"./data/language": "./src/data/language.json",
	"./data/language.json": "./src/data/language.json",
	"./data/useExtractor": "./src/data/useExtractor.js",
	"./data/useExtractor.js": "./src/data/useExtractor.js",
	"./pages/": "./src/pages/index.jsx",
	"./pages/activities": "./src/pages/activities/index.jsx",
	"./pages/activities/": "./src/pages/activities/index.jsx",
	"./pages/activities/[id]": "./src/pages/activities/[id].jsx",
	"./pages/activities/[id].jsx": "./src/pages/activities/[id].jsx",
	"./pages/activities/index": "./src/pages/activities/index.jsx",
	"./pages/activities/index.jsx": "./src/pages/activities/index.jsx",
	"./pages/admin": "./src/pages/admin/index.jsx",
	"./pages/admin/": "./src/pages/admin/index.jsx",
	"./pages/admin/index": "./src/pages/admin/index.jsx",
	"./pages/admin/index.jsx": "./src/pages/admin/index.jsx",
	"./pages/admin/user-statistics": "./src/pages/admin/user-statistics/index.jsx",
	"./pages/admin/user-statistics/": "./src/pages/admin/user-statistics/index.jsx",
	"./pages/admin/user-statistics/index": "./src/pages/admin/user-statistics/index.jsx",
	"./pages/admin/user-statistics/index.jsx": "./src/pages/admin/user-statistics/index.jsx",
	"./pages/audio-question": "./src/pages/audio-question/index.jsx",
	"./pages/audio-question/": "./src/pages/audio-question/index.jsx",
	"./pages/audio-question/create-question": "./src/pages/audio-question/create-question/index.jsx",
	"./pages/audio-question/create-question/": "./src/pages/audio-question/create-question/index.jsx",
	"./pages/audio-question/create-question/index": "./src/pages/audio-question/create-question/index.jsx",
	"./pages/audio-question/create-question/index.jsx": "./src/pages/audio-question/create-question/index.jsx",
	"./pages/audio-question/edit-audio": "./src/pages/audio-question/edit-audio/index.jsx",
	"./pages/audio-question/edit-audio/": "./src/pages/audio-question/edit-audio/index.jsx",
	"./pages/audio-question/edit-audio/index": "./src/pages/audio-question/edit-audio/index.jsx",
	"./pages/audio-question/edit-audio/index.jsx": "./src/pages/audio-question/edit-audio/index.jsx",
	"./pages/audio-question/index": "./src/pages/audio-question/index.jsx",
	"./pages/audio-question/index.jsx": "./src/pages/audio-question/index.jsx",
	"./pages/bulk-upload": "./src/pages/bulk-upload/index.jsx",
	"./pages/bulk-upload/": "./src/pages/bulk-upload/index.jsx",
	"./pages/bulk-upload/index": "./src/pages/bulk-upload/index.jsx",
	"./pages/bulk-upload/index.jsx": "./src/pages/bulk-upload/index.jsx",
	"./pages/category": "./src/pages/category.jsx",
	"./pages/category-order": "./src/pages/category-order/index.jsx",
	"./pages/category-order/": "./src/pages/category-order/index.jsx",
	"./pages/category-order/index": "./src/pages/category-order/index.jsx",
	"./pages/category-order/index.jsx": "./src/pages/category-order/index.jsx",
	"./pages/category.jsx": "./src/pages/category.jsx",
	"./pages/contest": "./src/pages/contest/index.jsx",
	"./pages/contest/": "./src/pages/contest/index.jsx",
	"./pages/contest/[id]": "./src/pages/contest/[id].jsx",
	"./pages/contest/[id].jsx": "./src/pages/contest/[id].jsx",
	"./pages/contest/create-contest": "./src/pages/contest/create-contest/index.jsx",
	"./pages/contest/create-contest/": "./src/pages/contest/create-contest/index.jsx",
	"./pages/contest/create-contest/index": "./src/pages/contest/create-contest/index.jsx",
	"./pages/contest/create-contest/index.jsx": "./src/pages/contest/create-contest/index.jsx",
	"./pages/contest/create-question": "./src/pages/contest/create-question/index.jsx",
	"./pages/contest/create-question/": "./src/pages/contest/create-question/index.jsx",
	"./pages/contest/create-question/index": "./src/pages/contest/create-question/index.jsx",
	"./pages/contest/create-question/index.jsx": "./src/pages/contest/create-question/index.jsx",
	"./pages/contest/distribute-prize": "./src/pages/contest/distribute-prize/index.jsx",
	"./pages/contest/distribute-prize/": "./src/pages/contest/distribute-prize/index.jsx",
	"./pages/contest/distribute-prize/index": "./src/pages/contest/distribute-prize/index.jsx",
	"./pages/contest/distribute-prize/index.jsx": "./src/pages/contest/distribute-prize/index.jsx",
	"./pages/contest/edit-contest": "./src/pages/contest/edit-contest/index.jsx",
	"./pages/contest/edit-contest/": "./src/pages/contest/edit-contest/index.jsx",
	"./pages/contest/edit-contest/index": "./src/pages/contest/edit-contest/index.jsx",
	"./pages/contest/edit-contest/index.jsx": "./src/pages/contest/edit-contest/index.jsx",
	"./pages/contest/index": "./src/pages/contest/index.jsx",
	"./pages/contest/index.jsx": "./src/pages/contest/index.jsx",
	"./pages/contest/questions": "./src/pages/contest/questions.jsx",
	"./pages/contest/questions.jsx": "./src/pages/contest/questions.jsx",
	"./pages/daily-quiz": "./src/pages/daily-quiz/index.jsx",
	"./pages/daily-quiz/": "./src/pages/daily-quiz/index.jsx",
	"./pages/daily-quiz/create-question": "./src/pages/daily-quiz/create-question/index.jsx",
	"./pages/daily-quiz/create-question/": "./src/pages/daily-quiz/create-question/index.jsx",
	"./pages/daily-quiz/create-question/index": "./src/pages/daily-quiz/create-question/index.jsx",
	"./pages/daily-quiz/create-question/index.jsx": "./src/pages/daily-quiz/create-question/index.jsx",
	"./pages/daily-quiz/index": "./src/pages/daily-quiz/index.jsx",
	"./pages/daily-quiz/index.jsx": "./src/pages/daily-quiz/index.jsx",
	"./pages/exam-module": "./src/pages/exam-module/index.jsx",
	"./pages/exam-module/": "./src/pages/exam-module/index.jsx",
	"./pages/exam-module/create-exam": "./src/pages/exam-module/create-exam/index.jsx",
	"./pages/exam-module/create-exam/": "./src/pages/exam-module/create-exam/index.jsx",
	"./pages/exam-module/create-exam/index": "./src/pages/exam-module/create-exam/index.jsx",
	"./pages/exam-module/create-exam/index.jsx": "./src/pages/exam-module/create-exam/index.jsx",
	"./pages/exam-module/create-question": "./src/pages/exam-module/create-question/index.jsx",
	"./pages/exam-module/create-question/": "./src/pages/exam-module/create-question/index.jsx",
	"./pages/exam-module/create-question/index": "./src/pages/exam-module/create-question/index.jsx",
	"./pages/exam-module/create-question/index.jsx": "./src/pages/exam-module/create-question/index.jsx",
	"./pages/exam-module/index": "./src/pages/exam-module/index.jsx",
	"./pages/exam-module/index.jsx": "./src/pages/exam-module/index.jsx",
	"./pages/exam-module/questions": "./src/pages/exam-module/questions.jsx",
	"./pages/exam-module/questions.jsx": "./src/pages/exam-module/questions.jsx",
	"./pages/fun": "./src/pages/fun/index.jsx",
	"./pages/fun/": "./src/pages/fun/index.jsx",
	"./pages/fun/create-fun": "./src/pages/fun/create-fun/index.jsx",
	"./pages/fun/create-fun/": "./src/pages/fun/create-fun/index.jsx",
	"./pages/fun/create-fun/index": "./src/pages/fun/create-fun/index.jsx",
	"./pages/fun/create-fun/index.jsx": "./src/pages/fun/create-fun/index.jsx",
	"./pages/fun/create-question": "./src/pages/fun/create-question/index.jsx",
	"./pages/fun/create-question/": "./src/pages/fun/create-question/index.jsx",
	"./pages/fun/create-question/index": "./src/pages/fun/create-question/index.jsx",
	"./pages/fun/create-question/index.jsx": "./src/pages/fun/create-question/index.jsx",
	"./pages/fun/edit-fun": "./src/pages/fun/edit-fun/index.jsx",
	"./pages/fun/edit-fun/": "./src/pages/fun/edit-fun/index.jsx",
	"./pages/fun/edit-fun/index": "./src/pages/fun/edit-fun/index.jsx",
	"./pages/fun/edit-fun/index.jsx": "./src/pages/fun/edit-fun/index.jsx",
	"./pages/fun/index": "./src/pages/fun/index.jsx",
	"./pages/fun/index.jsx": "./src/pages/fun/index.jsx",
	"./pages/fun/questions": "./src/pages/fun/questions.jsx",
	"./pages/fun/questions.jsx": "./src/pages/fun/questions.jsx",
	"./pages/guess-the-word": "./src/pages/guess-the-word/index.jsx",
	"./pages/guess-the-word/": "./src/pages/guess-the-word/index.jsx",
	"./pages/guess-the-word/create-guess-the-word": "./src/pages/guess-the-word/create-guess-the-word/index.jsx",
	"./pages/guess-the-word/create-guess-the-word/": "./src/pages/guess-the-word/create-guess-the-word/index.jsx",
	"./pages/guess-the-word/create-guess-the-word/index": "./src/pages/guess-the-word/create-guess-the-word/index.jsx",
	"./pages/guess-the-word/create-guess-the-word/index.jsx": "./src/pages/guess-the-word/create-guess-the-word/index.jsx",
	"./pages/guess-the-word/edit-guess-the-word": "./src/pages/guess-the-word/edit-guess-the-word/index.jsx",
	"./pages/guess-the-word/edit-guess-the-word/": "./src/pages/guess-the-word/edit-guess-the-word/index.jsx",
	"./pages/guess-the-word/edit-guess-the-word/index": "./src/pages/guess-the-word/edit-guess-the-word/index.jsx",
	"./pages/guess-the-word/edit-guess-the-word/index.jsx": "./src/pages/guess-the-word/edit-guess-the-word/index.jsx",
	"./pages/guess-the-word/index": "./src/pages/guess-the-word/index.jsx",
	"./pages/guess-the-word/index.jsx": "./src/pages/guess-the-word/index.jsx",
	"./pages/index": "./src/pages/index.jsx",
	"./pages/index.jsx": "./src/pages/index.jsx",
	"./pages/leaderboard": "./src/pages/leaderboard/index.jsx",
	"./pages/leaderboard/": "./src/pages/leaderboard/index.jsx",
	"./pages/leaderboard/[id]": "./src/pages/leaderboard/[id].jsx",
	"./pages/leaderboard/[id].jsx": "./src/pages/leaderboard/[id].jsx",
	"./pages/leaderboard/index": "./src/pages/leaderboard/index.jsx",
	"./pages/leaderboard/index.jsx": "./src/pages/leaderboard/index.jsx",
	"./pages/math-quiz": "./src/pages/math-quiz/index.jsx",
	"./pages/math-quiz/": "./src/pages/math-quiz/index.jsx",
	"./pages/math-quiz/create-question": "./src/pages/math-quiz/create-question/index.jsx",
	"./pages/math-quiz/create-question/": "./src/pages/math-quiz/create-question/index.jsx",
	"./pages/math-quiz/create-question/index": "./src/pages/math-quiz/create-question/index.jsx",
	"./pages/math-quiz/create-question/index.jsx": "./src/pages/math-quiz/create-question/index.jsx",
	"./pages/math-quiz/edit-question": "./src/pages/math-quiz/edit-question/index.jsx",
	"./pages/math-quiz/edit-question/": "./src/pages/math-quiz/edit-question/index.jsx",
	"./pages/math-quiz/edit-question/index": "./src/pages/math-quiz/edit-question/index.jsx",
	"./pages/math-quiz/edit-question/index.jsx": "./src/pages/math-quiz/edit-question/index.jsx",
	"./pages/math-quiz/index": "./src/pages/math-quiz/index.jsx",
	"./pages/math-quiz/index.jsx": "./src/pages/math-quiz/index.jsx",
	"./pages/notifications": "./src/pages/notifications/index.jsx",
	"./pages/notifications/": "./src/pages/notifications/index.jsx",
	"./pages/notifications/index": "./src/pages/notifications/index.jsx",
	"./pages/notifications/index.jsx": "./src/pages/notifications/index.jsx",
	"./pages/overview": "./src/pages/overview/index.jsx",
	"./pages/overview/": "./src/pages/overview/index.jsx",
	"./pages/overview/index": "./src/pages/overview/index.jsx",
	"./pages/overview/index.jsx": "./src/pages/overview/index.jsx",
	"./pages/overview/questions": "./src/pages/overview/questions/index.jsx",
	"./pages/overview/questions/": "./src/pages/overview/questions/index.jsx",
	"./pages/overview/questions/index": "./src/pages/overview/questions/index.jsx",
	"./pages/overview/questions/index.jsx": "./src/pages/overview/questions/index.jsx",
	"./pages/payment": "./src/pages/payment/index.jsx",
	"./pages/payment/": "./src/pages/payment/index.jsx",
	"./pages/payment/[id]": "./src/pages/payment/[id]/index.jsx",
	"./pages/payment/[id]/": "./src/pages/payment/[id]/index.jsx",
	"./pages/payment/[id]/index": "./src/pages/payment/[id]/index.jsx",
	"./pages/payment/[id]/index.jsx": "./src/pages/payment/[id]/index.jsx",
	"./pages/payment/index": "./src/pages/payment/index.jsx",
	"./pages/payment/index.jsx": "./src/pages/payment/index.jsx",
	"./pages/question-bank": "./src/pages/question-bank/index.jsx",
	"./pages/question-bank/": "./src/pages/question-bank/index.jsx",
	"./pages/question-bank/create-question": "./src/pages/question-bank/create-question/index.jsx",
	"./pages/question-bank/create-question/": "./src/pages/question-bank/create-question/index.jsx",
	"./pages/question-bank/create-question/index": "./src/pages/question-bank/create-question/index.jsx",
	"./pages/question-bank/create-question/index.jsx": "./src/pages/question-bank/create-question/index.jsx",
	"./pages/question-bank/import-questions": "./src/pages/question-bank/import-questions/index.jsx",
	"./pages/question-bank/import-questions/": "./src/pages/question-bank/import-questions/index.jsx",
	"./pages/question-bank/import-questions/index": "./src/pages/question-bank/import-questions/index.jsx",
	"./pages/question-bank/import-questions/index.jsx": "./src/pages/question-bank/import-questions/index.jsx",
	"./pages/question-bank/index": "./src/pages/question-bank/index.jsx",
	"./pages/question-bank/index.jsx": "./src/pages/question-bank/index.jsx",
	"./pages/question-bank/question-report": "./src/pages/question-bank/question-report/index.jsx",
	"./pages/question-bank/question-report/": "./src/pages/question-bank/question-report/index.jsx",
	"./pages/question-bank/question-report/index": "./src/pages/question-bank/question-report/index.jsx",
	"./pages/question-bank/question-report/index.jsx": "./src/pages/question-bank/question-report/index.jsx",
	"./pages/quiz-zone": "./src/pages/quiz-zone/index.jsx",
	"./pages/quiz-zone/": "./src/pages/quiz-zone/index.jsx",
	"./pages/quiz-zone/create-questions": "./src/pages/quiz-zone/create-questions/index.jsx",
	"./pages/quiz-zone/create-questions/": "./src/pages/quiz-zone/create-questions/index.jsx",
	"./pages/quiz-zone/create-questions/index": "./src/pages/quiz-zone/create-questions/index.jsx",
	"./pages/quiz-zone/create-questions/index.jsx": "./src/pages/quiz-zone/create-questions/index.jsx",
	"./pages/quiz-zone/edit-question": "./src/pages/quiz-zone/edit-question/index.jsx",
	"./pages/quiz-zone/edit-question/": "./src/pages/quiz-zone/edit-question/index.jsx",
	"./pages/quiz-zone/edit-question/index": "./src/pages/quiz-zone/edit-question/index.jsx",
	"./pages/quiz-zone/edit-question/index.jsx": "./src/pages/quiz-zone/edit-question/index.jsx",
	"./pages/quiz-zone/import-questions": "./src/pages/quiz-zone/import-questions/index.jsx",
	"./pages/quiz-zone/import-questions/": "./src/pages/quiz-zone/import-questions/index.jsx",
	"./pages/quiz-zone/import-questions/index": "./src/pages/quiz-zone/import-questions/index.jsx",
	"./pages/quiz-zone/import-questions/index.jsx": "./src/pages/quiz-zone/import-questions/index.jsx",
	"./pages/quiz-zone/index": "./src/pages/quiz-zone/index.jsx",
	"./pages/quiz-zone/index.jsx": "./src/pages/quiz-zone/index.jsx",
	"./pages/quiz-zone/question-report": "./src/pages/quiz-zone/question-report/index.jsx",
	"./pages/quiz-zone/question-report/": "./src/pages/quiz-zone/question-report/index.jsx",
	"./pages/quiz-zone/question-report/index": "./src/pages/quiz-zone/question-report/index.jsx",
	"./pages/quiz-zone/question-report/index.jsx": "./src/pages/quiz-zone/question-report/index.jsx",
	"./pages/settings": "./src/pages/settings/index.jsx",
	"./pages/settings/": "./src/pages/settings/index.jsx",
	"./pages/settings/about-us": "./src/pages/settings/about-us.jsx",
	"./pages/settings/about-us.jsx": "./src/pages/settings/about-us.jsx",
	"./pages/settings/about-us/": "./src/pages/settings/about-us/index.jsx",
	"./pages/settings/about-us/index": "./src/pages/settings/about-us/index.jsx",
	"./pages/settings/about-us/index.jsx": "./src/pages/settings/about-us/index.jsx",
	"./pages/settings/badge-settings": "./src/pages/settings/badge-settings/index.jsx",
	"./pages/settings/badge-settings/": "./src/pages/settings/badge-settings/index.jsx",
	"./pages/settings/badge-settings/index": "./src/pages/settings/badge-settings/index.jsx",
	"./pages/settings/badge-settings/index.jsx": "./src/pages/settings/badge-settings/index.jsx",
	"./pages/settings/contact-us": "./src/pages/settings/contact-us.jsx",
	"./pages/settings/contact-us.jsx": "./src/pages/settings/contact-us.jsx",
	"./pages/settings/contact-us/": "./src/pages/settings/contact-us/index.jsx",
	"./pages/settings/contact-us/index": "./src/pages/settings/contact-us/index.jsx",
	"./pages/settings/contact-us/index.jsx": "./src/pages/settings/contact-us/index.jsx",
	"./pages/settings/faq": "./src/pages/settings/faq/index.jsx",
	"./pages/settings/faq/": "./src/pages/settings/faq/index.jsx",
	"./pages/settings/faq/index": "./src/pages/settings/faq/index.jsx",
	"./pages/settings/faq/index.jsx": "./src/pages/settings/faq/index.jsx",
	"./pages/settings/howtoplay": "./src/pages/settings/howtoplay.jsx",
	"./pages/settings/howtoplay.jsx": "./src/pages/settings/howtoplay.jsx",
	"./pages/settings/icons-settings": "./src/pages/settings/icons-settings/index.jsx",
	"./pages/settings/icons-settings/": "./src/pages/settings/icons-settings/index.jsx",
	"./pages/settings/icons-settings/index": "./src/pages/settings/icons-settings/index.jsx",
	"./pages/settings/icons-settings/index.jsx": "./src/pages/settings/icons-settings/index.jsx",
	"./pages/settings/index": "./src/pages/settings/index.jsx",
	"./pages/settings/index.jsx": "./src/pages/settings/index.jsx",
	"./pages/settings/language-settings": "./src/pages/settings/language-settings/index.jsx",
	"./pages/settings/language-settings/": "./src/pages/settings/language-settings/index.jsx",
	"./pages/settings/language-settings/index": "./src/pages/settings/language-settings/index.jsx",
	"./pages/settings/language-settings/index.jsx": "./src/pages/settings/language-settings/index.jsx",
	"./pages/settings/payment-settings": "./src/pages/settings/payment-settings/index.jsx",
	"./pages/settings/payment-settings/": "./src/pages/settings/payment-settings/index.jsx",
	"./pages/settings/payment-settings/index": "./src/pages/settings/payment-settings/index.jsx",
	"./pages/settings/payment-settings/index.jsx": "./src/pages/settings/payment-settings/index.jsx",
	"./pages/settings/privacy-policy": "./src/pages/settings/privacy-policy.jsx",
	"./pages/settings/privacy-policy.jsx": "./src/pages/settings/privacy-policy.jsx",
	"./pages/settings/privacy-policy/": "./src/pages/settings/privacy-policy/index.jsx",
	"./pages/settings/privacy-policy/index": "./src/pages/settings/privacy-policy/index.jsx",
	"./pages/settings/privacy-policy/index.jsx": "./src/pages/settings/privacy-policy/index.jsx",
	"./pages/settings/sliders": "./src/pages/settings/sliders/index.jsx",
	"./pages/settings/sliders/": "./src/pages/settings/sliders/index.jsx",
	"./pages/settings/sliders/index": "./src/pages/settings/sliders/index.jsx",
	"./pages/settings/sliders/index.jsx": "./src/pages/settings/sliders/index.jsx",
	"./pages/settings/system-utilities": "./src/pages/settings/system-utilities/index.jsx",
	"./pages/settings/system-utilities/": "./src/pages/settings/system-utilities/index.jsx",
	"./pages/settings/system-utilities/index": "./src/pages/settings/system-utilities/index.jsx",
	"./pages/settings/system-utilities/index.jsx": "./src/pages/settings/system-utilities/index.jsx",
	"./pages/settings/terms": "./src/pages/settings/terms.jsx",
	"./pages/settings/terms.jsx": "./src/pages/settings/terms.jsx",
	"./pages/settings/users-rights": "./src/pages/settings/users-rights/index.jsx",
	"./pages/settings/users-rights/": "./src/pages/settings/users-rights/index.jsx",
	"./pages/settings/users-rights/index": "./src/pages/settings/users-rights/index.jsx",
	"./pages/settings/users-rights/index.jsx": "./src/pages/settings/users-rights/index.jsx",
	"./pages/settings/welcome-bonus": "./src/pages/settings/welcome-bonus/index.jsx",
	"./pages/settings/welcome-bonus/": "./src/pages/settings/welcome-bonus/index.jsx",
	"./pages/settings/welcome-bonus/index": "./src/pages/settings/welcome-bonus/index.jsx",
	"./pages/settings/welcome-bonus/index.jsx": "./src/pages/settings/welcome-bonus/index.jsx",
	"./pages/users": "./src/pages/users/index.jsx",
	"./pages/users/": "./src/pages/users/index.jsx",
	"./pages/users/index": "./src/pages/users/index.jsx",
	"./pages/users/index.jsx": "./src/pages/users/index.jsx",
	"./pages/users/user-statistics": "./src/pages/users/user-statistics/index.jsx",
	"./pages/users/user-statistics/": "./src/pages/users/user-statistics/index.jsx",
	"./pages/users/user-statistics/index": "./src/pages/users/user-statistics/index.jsx",
	"./pages/users/user-statistics/index.jsx": "./src/pages/users/user-statistics/index.jsx",
	"./screens/home": "./src/screens/home.jsx",
	"./screens/home.jsx": "./src/screens/home.jsx",
	"./screens/login": "./src/screens/login/index.jsx",
	"./screens/login/": "./src/screens/login/index.jsx",
	"./screens/login/index": "./src/screens/login/index.jsx",
	"./screens/login/index.jsx": "./src/screens/login/index.jsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/.*\\/.*$";